/* treatmentPatternsThunk.ts */

/* Redux-Toolkit */
import { createAsyncThunk } from "@reduxjs/toolkit";

/* Axios */
import axios, { HttpStatusCode } from "axios";

/* Utils */
import axiosInterceptor from "src/utils/helper/axios-interceptor";
import { InsightsFilterRequestDto } from "src/utils/dto/insights-filter/InsightsFilterRequestDto";
import { BaseChartResponseDto } from "src/utils/dto/charts/BaseChartResponseDto";
import { transformTreatmentData } from "src/utils/helper/treatment-patterns/transformTreatmentData";
import { ClientError } from "src/utils/status-handling/ClientError";

/* Constants */
import { ErrorMessage } from "src/shared/constants/common/ErrorMessage";

/* Constants */
import { ChartType } from "src/shared/constants/charts/Chart";

/* Interfaces */
import { BaseChartProps } from "src/shared/interfaces/charts/BaseChart";
import { TreatmentPatternsProps } from "src/shared/interfaces/TreatmentPatterns";
import { TreatmentPatternsInsightsFilterRequest } from "src/shared/interfaces/api/TreatmentPatterns";

export const fetchTreatmentPatterns = createAsyncThunk<
  BaseChartProps<TreatmentPatternsProps[], ChartType[][]>,
  TreatmentPatternsInsightsFilterRequest,
  {
    rejectValue: ClientError;
  }
>(
  "treatmentPatterns/fetchTreatmentPatterns",
  async (params, { rejectWithValue }) => {
    try {
      const requestParams =
        InsightsFilterRequestDto.toTreatmentPatternsInsightsFilterRequest(
          params
        );

      const response = await axiosInterceptor.get(
        "/data/treatment_patterns",
        {
          params: requestParams,
          paramsSerializer: { indexes: null },
        }
      );

      const { width } = params;

      if (
        response.status === HttpStatusCode.NoContent ||
        !response.data
      ) {
        return rejectWithValue(ClientError.noContent());
      }

      const dto = BaseChartResponseDto.fromApi(
        response.data,
        (data: any) => transformTreatmentData(data, width)
      );
      const result = dto.toObject();
      return result;
    } catch (error) {
      console.error(error);
      if (
        axios.isAxiosError(error) &&
        error.response?.status === HttpStatusCode.Forbidden
      ) {
        return rejectWithValue(ClientError.forbidden(ErrorMessage.NO_CARE_SITE_ACCESS));
      }
      if (error instanceof ClientError) {
        return rejectWithValue(error);
      }
      return rejectWithValue(ClientError.internal());
    }
  }
);
